var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.9496,
    y1: 241.8545,
    x2: 236.4296,
    y2: 87.3845,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ECCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M177.429,397.457H20.287V202.435c0-10.817,8.769-19.587,19.587-19.587h137.555 L177.429,397.457L177.429,397.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.2286,
    y1: 225.5285,
    x2: 208.7386,
    y2: 225.5285,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F88C9",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 109.036,
    y: 182.845,
    style: {
      fill: "url(#SVGID_2_)"
    },
    width: 68.397,
    height: 214.608
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.4811,
    y1: 281.826,
    x2: 419.2711,
    y2: 94.046,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9EB644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    style: {
      stopColor: "#9CB441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M334.571,397.457H177.429V124.753c0-10.817,8.769-19.587,19.587-19.587h117.969 c10.817,0,19.587,8.769,19.587,19.587V397.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.7398,
    y1: 210.7847,
    x2: 526.4998,
    y2: 76.0347,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E24786"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M491.713,397.457H334.571V240.315h137.555c10.817,0,19.587,8.769,19.587,19.587 L491.713,397.457L491.713,397.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.9706,
    y1: 132.0055,
    x2: 263.0506,
    y2: 266.9255,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E2E4F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    points: "491.713,397.457 334.571,397.457 334.571,240.315 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.9115,
    y1: 186.8357,
    x2: 0.4915,
    y2: 127.0857,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F88C9",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.289,
    y: 293.868,
    style: {
      fill: "url(#SVGID_6_)"
    },
    width: 157.144,
    height: 103.585
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8136,
    y1: 188.3835,
    x2: 254.8136,
    y2: 128.6335,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#738611",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 177.433,
    y: 293.868,
    style: {
      fill: "url(#SVGID_7_)"
    },
    width: 157.144,
    height: 103.585
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.9266,
    y1: 168.6718,
    x2: 2.7666,
    y2: 108.9218,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E2E4F"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334.567,
    y: 293.868,
    style: {
      fill: "url(#SVGID_8_)"
    },
    width: 157.144,
    height: 103.585
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.2805,
    y1: 138.8054,
    x2: 324.8705,
    y2: 287.2254,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E2E4F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M491.713,318.564l-53.393-53.393c-5.202-5.559-13.501-8.36-24.943-8.36 c-6.055,0-11.351,0.888-15.891,2.661c-4.541,1.776-7.985,4.071-10.334,6.889c-2.348,2.818-4.046,5.637-5.088,8.455 c-1.045,2.818-1.566,5.637-1.566,8.455c0,3.029,0.548,5.064,1.644,6.106c0.198,0.189,0.451,0.354,0.729,0.509l48.786,49.54 c-0.198,6.081-1.714,10.575-4.579,13.44c-3.081,3.08-7.856,4.618-14.327,4.618c-0.669,0-1.314-0.022-1.948-0.056 c-0.052-0.048-0.089-0.111-0.145-0.158l-18.183-18.183c-1.201-0.99-3.472-1.488-6.81-1.488c-2.818,0-4.803,0.497-5.95,1.488 c-1.15,0.994-1.723,2.845-1.723,5.559c0,7.1,2.948,13.465,8.847,19.102c0.036,0.035,0.075,0.066,0.112,0.1l33.599,33.607h71.163 v-78.892H491.713z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.8086,
    y1: 128.0535,
    x2: 254.8086,
    y2: 101.8835,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E2EDF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FC7E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M500.697,406.834H11.303C5.061,406.834,0,401.773,0,395.532 c0-6.242,5.061-11.303,11.303-11.303h489.394c6.242,0,11.303,5.061,11.303,11.303C512,401.773,506.939,406.834,500.697,406.834z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.6774,
    y1: 205.5523,
    x2: 222.6774,
    y2: 303.5523,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#738611",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#738611"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M334.571,260.773l-65.262-65.278c-1.515-0.99-3.21-1.488-5.089-1.488 c-1.671,0-3.08,0.575-4.227,1.723l-16.284,15.657c-2.193,1.565-3.288,3.705-3.288,6.419c0,1.671,0.548,3.209,1.644,4.618 l12.916,12.936v67.776c0,1.613,0.76,2.906,2.27,3.885l77.319,77.319V260.773H334.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.421,217.806c0-2.714,1.096-4.854,3.288-6.419l16.284-15.657 c1.147-1.147,2.556-1.723,4.227-1.723c1.879,0,3.574,0.497,5.089,1.488c1.511,0.994,2.27,2.324,2.27,3.993v103.649 c0,1.672-0.837,3.002-2.505,3.993c-1.672,0.994-3.601,1.488-5.794,1.488c-2.297,0-4.254-0.494-5.871-1.488 c-1.62-0.991-2.427-2.321-2.427-3.993v-87.052l-5.48,6.889c-1.044,1.045-2.192,1.566-3.444,1.566c-1.566,0-2.896-0.705-3.993-2.114 C240.969,221.016,240.421,219.477,240.421,217.806z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.2592,
    y1: 154.0741,
    x2: 5.7612,
    y2: 313.5741,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5618)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F88C9",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3FA9F5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M177.429,293.46l-55.086-55.091c-6.523-5.817-14.431-8.726-23.72-8.726 c-8.767,0-16.311,2.583-22.624,7.751c-6.317,5.166-9.472,11.821-9.472,19.962c0,4.361,1.262,7.17,3.774,8.442l23.374,23.374 c0.024,0.045,0.049,0.089,0.074,0.134l-11.252,8.19c-4.983,3.65-9.179,7.716-12.584,12.198c-3.405,4.483-5.108,9.069-5.108,13.761 v15.167c0,1.566,0.802,2.867,2.41,3.909l54.926,54.926h55.289V293.46H177.429z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M64.804,338.622v-15.168c0-4.691,1.703-9.278,5.108-13.761c3.405-4.482,7.601-8.547,12.584-12.198 l15.031-10.94c5.01-3.645,9.262-7.657,12.76-12.034c3.496-4.374,5.244-8.751,5.244-13.127c0-4.374-1.436-8.203-4.305-11.486 c-2.873-3.28-7.073-4.922-12.604-4.922c-4.696,0-8.508,1.296-11.429,3.887c-2.923,2.591-4.384,6.425-4.384,11.501 c0,1.658-0.81,3.112-2.426,4.355c-1.62,1.243-3.734,1.864-6.342,1.864c-5.01,0-7.515-3.078-7.515-9.237 c0-8.142,3.155-14.796,9.472-19.962c6.314-5.167,13.857-7.751,22.624-7.751c9.288,0,17.196,2.909,23.72,8.726 c6.522,5.818,9.786,13.335,9.786,22.558c0,6.253-1.749,12.112-5.245,17.583c-3.499,5.47-7.726,10.105-12.683,13.907 c-4.958,3.804-9.918,7.398-14.874,10.783c-4.958,3.385-9.186,6.799-12.682,10.236c-3.499,3.439-5.244,6.773-5.244,10.003v5.937 h46.032c1.461,0,2.74,0.705,3.836,2.114c1.096,1.41,1.644,3.107,1.644,5.088c0,1.984-0.546,3.733-1.634,5.245 c-1.089,1.514-2.358,2.27-3.81,2.27H72.112c-1.658,0-3.293-0.521-4.897-1.563C65.606,341.489,64.804,340.188,64.804,338.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M377.992,344.647c0-2.713,0.572-4.565,1.723-5.559c1.146-0.99,3.131-1.488,5.95-1.488 c3.339,0,5.609,0.497,6.81,1.488c1.199,0.994,1.801,2.583,1.801,4.776c0,3.758,1.59,6.966,4.776,9.629 c3.182,2.661,7.75,3.993,13.7,3.993c6.471,0,11.246-1.539,14.327-4.618c3.077-3.077,4.618-8.009,4.618-14.796v-2.975 c0-11.375-6.368-17.066-19.102-17.066c-3.55,0-5.323-2.165-5.323-6.497c0-4.435,1.774-6.654,5.323-6.654 c5.324,0,9.368-1.199,12.134-3.602c2.765-2.399,4.149-6.94,4.149-13.621c0-10.749-5.22-16.127-15.656-16.127 c-5.847,0-10.021,1.219-12.526,3.65c-2.505,2.434-3.758,5.462-3.758,9.085c0,4.452-2.61,6.679-7.829,6.679 c-3.55,0-5.872-0.521-6.967-1.566c-1.095-1.042-1.644-3.077-1.644-6.106c0-2.818,0.521-5.637,1.566-8.455 c1.042-2.818,2.74-5.637,5.088-8.455c2.349-2.818,5.794-5.113,10.334-6.889c4.54-1.774,9.836-2.661,15.891-2.661 c20.98,0,31.471,9.344,31.471,28.025c0,6.352-1.123,11.817-3.366,16.396c-2.246,4.58-5.299,7.806-9.159,9.68 c10.647,4.169,15.97,12.246,15.97,24.234v2.97c0,11.78-3.288,20.405-9.865,25.878c-6.576,5.473-15.186,8.208-25.834,8.208 c-11.272,0-19.86-2.818-25.755-8.455C380.94,358.111,377.992,351.746,377.992,344.647z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRanking);
export default __webpack_public_path__ + "static/media/icon-ranking.9cf6cdaed0e522cb25649fa28e99c8cf.svg";
export { ForwardRef as ReactComponent };